/**
 * Normalize Vuetify 2 space-separated color tokens to Vuetify 3 hyphen syntax.
 * e.g. "grey darken-1" → "grey-darken-1"
 */
export function normalizeVuetifyColor(value) {
  if (!value || typeof value !== 'string') return value;
  return value.replace(/(\w+)\s+(darken|lighten)-(\d+)/g, '$1-$2-$3');
}

/**
 * Split btn-class strings into layout classes and an optional Vuetify color token.
 */
export function parseBtnClass(btnClass) {
  if (!btnClass || typeof btnClass !== 'string') {
    return { layoutClass: '', color: undefined };
  }

  const tokens = btnClass.trim().split(/\s+/);
  const layout = [];
  const colorParts = [];
  const colorNames = new Set([
    'primary', 'secondary', 'accent', 'error', 'info', 'success', 'warning',
    'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue',
    'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber',
    'orange', 'deep-orange', 'brown', 'blue-grey', 'grey', 'gray', 'black',
    'white', 'background', 'default-panel', 'default-content',
  ]);

  for (let i = 0; i < tokens.length; i += 1) {
    const token = tokens[i];
    const next = tokens[i + 1];
    const hyphenColor = token.match(/^(\w+(?:-\w+)*)-(darken|lighten)-(\d+)$/);

    if (hyphenColor) {
      colorParts.push(token);
      continue;
    }

    if (colorNames.has(token)) {
      if (next && /^(darken|lighten)-\d+$/.test(next)) {
        colorParts.push(token, next);
        i += 1;
      } else {
        colorParts.push(token);
      }
      continue;
    }

    layout.push(token);
  }

  const color = colorParts.length ? normalizeVuetifyColor(colorParts.join(' ')) : undefined;
  return { layoutClass: layout.join(' '), color };
}
